












































































import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, classClients, classEdit, studentDel } from '@/api/admin'
import conFirm from './confirm.vue'
import bindStudent from './binding_student.vue'

@Component({
  components: {
    conFirm,
    bindStudent
  }
})
export default class BindingClients extends ViewBase {
  @Prop({ type: Number, default: 0 }) id!: number
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  lang = {}
  delId = []
  selectedRowKeys: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  created() {

    this.lang = this.i18n.vBinding
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.devicenum,
        // className: 'colName',
        dataIndex: 'id'
      },
      {
        title: lang.mac,
        // className: 'wid185',
        dataIndex: 'mac'
      },

      {
        title: lang.studentname,
        // className: 'wid185',
        dataIndex: 'name'
        // scopedSlots: { customRender: 'subjectid' }
      },
      {
        title: lang.handle,
        dataIndex: 'operation',
        className: 'texcenter wid370',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetch({
      class_id: this.id,
      page: 1
    })
  }
  relist() {
    this.editVisible = false
    this.fetch({
      class_id: this.id,
      page: this.pagination.current
    })
  }
  onSelectChange(selectedRowKeys: any) {
    // console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys
  }
  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current,
      class_id: this.id
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await classClients(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination
      this.selectedRowKeys = []
    } catch (ex) {
      this.handleError(ex)
    }
  }
  cancelMod() {
    this.editVisible = false
    this.delVisible = false
  }
  moredelStudent() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vBinding.plasechose)
    } else {
      this.delItem = {}
      this.delId = id
      this.delVisible = true
    }
  }
  editStudentshow(item: any) {
    const ddd = Object.assign({}, item)
    ddd.name = ddd.name + ''
    this.editItem = ddd
    this.editVisible = true
  }
  delStudentshow(item: any) {
    const id: any = []
    id.push(item.id)
    this.delId = id
    this.delItem = item
    this.delVisible = true
  }
  editbinding(item: any) {
    this.editItem = {}
    this.editVisible = true
  }
  async addclass(name: any) {
    const itme: any = this.editItem
    const pdata: any = {
      class_id: itme.id || '',
      name: name + ''
    }
    try {
      const res = await classEdit(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.editVisible = false

      this.fetch({
        page: 1,
        class_id: this.id
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async delclass() {
    const itme: any = this.delItem
    const pdata: any = {
      class_id: this.id || '',
      cid_list: this.delId
    }
    try {
      const res = await studentDel(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.delVisible = false

      this.fetch({
        page: 1,
        class_id: this.id
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
